import { render, staticRenderFns } from "./StatusPrnView.vue?vue&type=template&id=bdad5236&scoped=true"
import script from "./StatusPrnView.vue?vue&type=script&lang=js"
export * from "./StatusPrnView.vue?vue&type=script&lang=js"
import style0 from "./StatusPrnView.vue?vue&type=style&index=0&id=bdad5236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdad5236",
  null
  
)

export default component.exports